import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import type { SettlementReportSearch } from '@/features/payroll-settlement-report/api'
import { PayrollSettlementReportScreen } from '@/features/payroll-settlement-report/payroll-settlement-report-screen'
import { hasGrant } from '@/lib/me'

const branchSearchSchema = z.string().catch('all')

export const Route = createFileRoute('/_authenticated/payroll/settlements/$runId')({
  validateSearch: (search: Record<string, unknown>): SettlementReportSearch => ({
    method: search.method === 'bank_transfer' || search.method === 'cash' ? search.method : 'all',
    status: search.status === 'paid' || search.status === 'unpaid' ? search.status : 'all',
    branch: branchSearchSchema.parse(search.branch),
    search: typeof search.search === 'string' ? search.search : undefined,
    page: typeof search.page === 'number' ? search.page : 1,
    per_page: typeof search.per_page === 'number' ? search.per_page : 25,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'payroll_report.view'))
      throw redirect({ to: '/payroll/runs' })
  },
  component: SettlementReportRoute,
})

function SettlementReportRoute() {
  const { runId } = Route.useParams()
  return <PayrollSettlementReportScreen runId={runId} />
}
